import React, { useState } from 'react'
//section arrow assets
import uparrow from "../../assets/up-arrow.png"
import downarrow from "../../assets/down-arrow.png"


import { Link } from 'react-router-dom'
import languages_img from "../../assets/webimage.jpg"
import html from "../../assets/html5.png"
import css from "../../assets/css3.png"
import js from "../../assets/javascript.png"
import react from "../../assets/reactjs.png"
import node from "../../assets/nodejs.png"
import mongo from "../../assets/mongodb.svg"
import php from "../../assets/php.png"
import python from "../../assets/python.svg"
import sql from "../../assets/sql.svg"
import c from '../../assets/c.png'
import cplus from '../../assets/c++.png'
import java from '../../assets/java.png'
import ai from '../../assets/ai.png'
import "./Web.css"

const Web = () => {

  //state for section
  const [openSection,setOpenSection] =useState(null);

  //functiom to toogle section 
  const toogleSection =(section)=>{
    setOpenSection(openSection === section ? null : section);
  }
  return (
    <>
    <div className='margin'>
        <h1 className='para1'>We Develop All Kinds of Web Applications</h1>
        <img src={languages_img} alt="" />
        <p className='para2'>At Sinewavetechnologies, we specialize in building cutting-edge web applications
           tailored to your needs. Our team develops robust, scalable, and user-friendly solutions using the latest technologies
            like React.js, PHP, and Node.js. Whether it's a dynamic website, an e-commerce platform, 
            or a business management system, we ensure high performance and seamless user experience.
             With expertise in frontend, backend, and full-stack development, we bring your ideas to life efficiently.
              Let us help you create innovative digital solutions that drive success!</p>
       
       <div className='language_img'>
        <img src={html} alt="" />
        <img src={css} alt="" />
        <img src={js} alt="" />
        <img src={react} alt="" />
        <img src={node} alt="" />
        <img src={mongo} alt="" />
        <img src={php} alt="" />
        <img src={sql} alt="" />
        <img src={python} alt="" />
        <img src={java} alt="" />
        <img src={c} alt="" />
        <img src={cplus} alt="" />
        <img src={ai} alt="" />
      </div>
      <div className='skills'>
        <div className='category'>
            <h1 className='fh' >
              Frontend technologies {openSection === "frontend" ? <img src={uparrow} alt="" onClick={()=>toogleSection("frontend")} /> : <img src={downarrow} alt="" onClick={()=>toogleSection("frontend")}/> }
            </h1>
            {openSection === "frontend" && (
              <div className='lan'>
                 <p>Html5</p>
                 <hr/>
                 <p>Css3</p>
                 <hr/>
                 <p>Javascript</p>
                 <hr/>
                 <p>Reactjs</p>
                 <hr />
                 <p>"We specialize in building responsive and interactive frontend experiences using modern technologies like HTML5, CSS3, JavaScript, and React.js, ensuring seamless user interfaces for both static and dynamic web applications."</p>
              </div>
            )}
           </div>

         <div className='category'>
            <h1 className='bh'>
             Backend technologies {openSection=== "backend" ? <img src={uparrow} alt="" onClick={()=>toogleSection("backend")}/> : <img src={downarrow} alt="" onClick={()=>toogleSection("backend")}/> }
            </h1>
           {openSection === 'backend' && (
                <div className='lan2'>
                 <p>Nodejs</p>
                 <hr/>
                 <p>Expressjs</p>
                 <hr/>
                 <p>Python</p>
                 <hr/>
                 <p>Java</p>
                 <hr />
                 <p>Php</p>
                 <hr />
                 <p>"We develop scalable and secure backend solutions using Node.js, PHP, Python, and Java. Our backend architectures ensure seamless data management, API integrations, and optimized server-side performance."</p>
                </div>
           )}
         </div>
      
      {/* third section */}
       <div className='category' >
       <h1 className='fsh'>Fullstack technologies {openSection === "fullstack" ? <img src={uparrow} alt="" onClick={()=>toogleSection("fullstack")} /> : <img src={downarrow} alt=""  onClick={()=>toogleSection("fullstack")}/> }</h1>
        {openSection === "fullstack" && (
          <div className='lan3'>
                <p>MERN</p>
                 <hr/>
                 <p>MEAN</p>
                 <hr/>
                 <p>Java</p>
                 <hr />
                 <p>"We offer end-to-end web development solutions using MERN, Django, and Laravel. From designing interactive user interfaces to implementing robust backend logic, we build complete, high-performance application."</p>
          </div>
        )} 
        </div>  
      
      {/*fourth section*/}
      <div className='category'>
      <h1 className='dh'>Database {openSection === "database" ?  <img src={uparrow} alt="" onClick={()=>toogleSection("database")} /> : <img src={downarrow} alt="" onClick={()=>toogleSection("database")} /> }  </h1>
      {
        openSection === "database" && (
          <div className='lan4'>
                 <p>Mongo DB</p>
                 <hr/>
                 <p>Sql</p>
                 <hr />
                 <p>"We design and manage efficient databases using MongoDB and SQL to handle structured and unstructured data. Our database solutions ensure data integrity, fast retrieval, and secure storage for applications of any scale."</p>
          </div>
        )
}
</div>
     
     {/*fifth section */}
     <div className='category'>
       <h1 className='eh'>Embeded technologies {openSection ==="embeded" ? <img src={uparrow} alt="" onClick={()=>toogleSection("embeded")}/> :<img src={downarrow} alt="" onClick={()=>toogleSection("embeded")} />  }</h1>
       {openSection === "embeded" &&(
        <div className='lan5'>
               <p>C</p>
                 <hr/>
               <p>C++</p>
               <hr />
               <p>"We develop embedded solutions that integrate hardware with software for real-time applications. Using technologies like C, C++, and Python, we create efficient, low-latency systems for IoT, automation, and industrial applications."</p>
        </div>
       )}
     </div>
     
     
     <div className='category'>
         <h1 className='oh'>Other services {openSection === "others" ? <img src={uparrow} alt="" onClick={()=>toogleSection("others")} />:<img src={downarrow} alt="" onClick={()=>toogleSection("others")} /> }</h1>
         {openSection === "others" &&(
          <div className='lan6'>
                <p>customized web applications</p>
                 <hr/>
                 <p>Billing softwares</p>
                 <hr/>
          </div>
         )}
     </div>
       
    </div>
      
      <div className='hrbtns'>
        <hr />
         <button className='buttonforlink'> <Link to='/projects' className='spllink2'>Back to projects</Link> </button>
       </div>  
      
      </div>
      
       </>
  )
}

export default Web